export default "__VITE_ASSET__D7yB$k1b__"